<template>
  <div>
    <b-container fluid>
      <b-row align-h="between">
        <h1>フレームタイプ</h1>
        <button
          class="btn btn-outline-secondary"
          @click="pageBack"
        >戻る</button>
      </b-row>
      <b-table
        :fields="fields"
        :items="frameTypes"
        bordered
      >
        <template v-slot:cell(delete)="data">
          <b-row align-h="around">
            <button
              @click="deleteFrameType(data)"
              class="btn btn-outline-danger"
            >削除</button>
          </b-row>
        </template>
      </b-table>
      <b-row align-h="center">
        <b-col sm=6>
          <b-card title="システム機能分類追加">
            <small>※番号は自動で採番されます</small>
            <b-form-group
              label="システム機能分類"
              label-for="add_frame_type"
              label-cols=3
            >
              <b-form-input
                v-model="addFrameTypeName"
                id="add_frame_type"
              ></b-form-input>
            </b-form-group>
            <button
              class="btn btn-outline-info"
              @click="createFrameTypeName"
            >追加</button>
          </b-card>
        </b-col>
        <b-col sm=6>
          <b-card title="システム機能分類更新">
              <b-form-group
                label="番号"
                label-for="update_frame_type"
                label-cols=3
              >
              <b-form-input
                v-model="updateFrameType.no"
                id="update_frame_type_no"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="名称"
              label-for="update_frame_type"
              label-cols=3
            >
              <b-form-input
                v-model="updateFrameType.name"
                id="update_frame_type_name"
              ></b-form-input>
            </b-form-group>
            <button
              class="btn btn-outline-info"
              @click="updateFrameTypeName"
            >更新</button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'FrameType',
  data () {
    return {
      frameTypes: [],
      fields: [
        { key: 'no', label: '番号', sortable: true },
        { key: 'frame_type', label: 'システム機能分類', sortable: true },
        { key: 'delete', label: '削除/更新' }
      ],
      addFrameTypeName: '',
      showRegister: false,
      updateFrameType: {
        no: '',
        name: ''
      }
    }
  },
  async created () {
    this.listFrameTypes()
  },
  methods: {
    async listFrameTypes () {
      const funcClasses = await API.graphql(graphqlOperation(`
        query listFrameType {
          listFrameType{
            no
            frame_type
          }
        }
      `))
      this.$log.debug(funcClasses)
      this.frameTypes = [...funcClasses.data.listFrameType]
    },
    async deleteFrameType (args) {
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation deleteFrameType {
            deleteFrameType (
              no: ${args.item.no}
            ){
              no
              frame_type
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '削除に成功しました', 'info')
        this.listFrameTypes()
      } catch {
        this.makeToast('失敗', '削除に失敗しました', 'danger')
      }
    },
    async createFrameTypeName () {
      if (this.addFrameTypeName === '') {
        this.makeToast('失敗', '追加に失敗しました', 'danger')
        return
      }
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation createFrameType {
            createFrameType (
              frame_type: "${this.addFrameTypeName}"
            ){
              no
              frame_type
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '追加に成功しました', 'info')
        this.addFrameTypeName = ''
        this.listFrameTypes()
      } catch {
        this.makeToast('失敗', '追加に失敗しました', 'danger')
      }
    },
    async updateFrameTypeName () {
      if (this.updateFrameType.no === '' || this.updateFrameType.name === '') {
        this.makeToast('失敗', '更新に失敗しました', 'danger')
        return
      }
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation updateFrameType {
            updateFrameType (
              input:{
                no: ${this.updateFrameType.no}
                frame_type: "${this.updateFrameType.name}"
              }
            ){
              no
              frame_type
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '更新に成功しました', 'info')
        this.addFrameTypeName = ''
        this.listFrameTypes()
      } catch {
        this.makeToast('失敗', '更新に失敗しました', 'danger')
      }
    },
    pageBack () {
      this.$router.go(-1)
    }
  }
}
</script>
